export const DEMO_TOKEN = 'demo-access-token';
export const DEMO_REFRESH_TOKEN = 'demo-refresh-token';
export const DEMO_COMPANY = 'Acme Operations';

export const DEMO_ADMIN_USER = {
  id: 101,
  name: 'Avery Admin',
  full_name: 'Avery Admin',
  email: 'admin@acmeops.demo',
  organization: DEMO_COMPANY,
  team_name: 'Operations',
  role: 'admin',
  is_admin: true,
  is_superuser: true,
  profilePicture: null,
};

